import { servicesAsync } from 'Common/environment/environment'

import genericClient from './genericFetchClient'

export type { RequestConfig, ResponseErrorConfig, ResponseConfig } from './genericFetchClient'

const client = await genericClient(await servicesAsync.work(''))

export default client
